import { keyframes } from 'styled-components';

import type { PolyLoaderConfig } from './PolyLoaderConfig';

export const wave = (config: PolyLoaderConfig) => keyframes`
  0%   { transform: scale(1);    color: ${config.fill};       }
  5%   { transform: scale(1.08); color: ${config.fill};       }
  15%  { transform: scale(1.15); color: ${config.fillActive}; }
  50%  { transform: scale(1.08); color: ${config.fillActive}; }
  85%  { transform: scale(1);    color: ${config.fill};       }
  100% { transform: scale(1);    color: ${config.fill};       }
`;
